import { askChatGPT } from '../../ChatGPTInterface/api';

function extractTexts(node, results = []) {
  if (node.type === 'text' && typeof node.text === 'string') {
    results.push(node.text);
  }
  if (node.content) {
    node.content.forEach((child) => extractTexts(child, results));
  }
  return results;
}

function reinjectTexts(node, texts, index = { value: 0 }) {
  const clone = { ...node };
  if (node.type === 'text' && typeof node.text === 'string') {
    clone.text = texts[index.value];
    index.value += 1;
  }
  if (node.content) {
    clone.content = node.content.map((child) => reinjectTexts(child, texts, index));
  }
  return clone;
}

async function translateTipTap(tipTapJSON, language, nlpConstants) {
  const texts = extractTexts(tipTapJSON);
  if (!texts.length) return tipTapJSON;

  const prompt = `Translate the following JSON array of strings to ${language}.
Return only a valid JSON array of translated strings in the same order.
Do not translate proper nouns, email addresses, or place names.
${JSON.stringify(texts)}`;

  // Translation can take longer than the default NLP timeout — override to 120s
  const translationNlpConstants = nlpConstants
    ? {
        ...nlpConstants,
        WAIT_NLP_RESPONSE_TIMEOUT_LIMIT: {
          ...nlpConstants.WAIT_NLP_RESPONSE_TIMEOUT_LIMIT,
          value: '120',
        },
      }
    : null;

  const response = await askChatGPT({
    messages: [{ role: 'user', content: prompt }],
    nlpConstants: translationNlpConstants,
  });

  let translated;
  try {
    const match = response.match(/\[[\s\S]*\]/);
    translated = JSON.parse(match ? match[0] : response);
  } catch {
    throw new Error('Translation failed: could not parse response');
  }

  if (!Array.isArray(translated)) {
    throw new Error('Translation failed: response is not an array');
  }
  if (translated.length !== texts.length) {
    console.warn(`Translation length mismatch: expected ${texts.length}, got ${translated.length}`);
    // Pad with originals if response is shorter so no text node gets undefined
    while (translated.length < texts.length) {
      translated.push(texts[translated.length]);
    }
  }

  return reinjectTexts(tipTapJSON, translated);
}

export { extractTexts, reinjectTexts, translateTipTap };
